import styled from '@emotion/styled';
import { TableCell, TableHead, TableRow } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { customPalette } from '../../../../styles/theme';

export const Wrapper = styled.div`
  background-color: ${customPalette.accent.white};
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: none;
  box-sizing: border-box;

  .MuiPagination-root {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding-top: 24px;
  }

  .MuiPaginationItem-root {
    color: ${customPalette.accent.main};

    &.Mui-selected {
      background-color: ${customPalette.accent.main};
      color: ${customPalette.accent.white};
    }
  }

  @media (max-width: 600px) {
    .table-wrapper {
      overflow-x: auto;
      scrollbar-width: thin;
      scrollbar-color: ${customPalette.accent.main}
        ${customPalette.accent.white};
    }

    .table-wrapper::-webkit-scrollbar {
      height: 8px;
    }

    .table-wrapper::-webkit-scrollbar-thumb {
      background-color: ${customPalette.accent.main};
      border-radius: 4px;
    }

    .table-wrapper::-webkit-scrollbar-track {
      background: ${customPalette.accent.white};
    }
  }

  .skeleton-table {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .skeleton-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }
`;

export const StyledTableCell = styled(TableCell)`
  border-bottom: none;
  padding: 16px 0;
  text-align: left;
  display: flex;
  align-items: center;

  &:nth-of-type(1) {
    flex: 1 1 40%;
  }

  &:nth-of-type(2) {
    flex: 1 1 20%;
  }

  &:nth-of-type(3) {
    flex: 1 1 25%;
  }

  &:nth-of-type(4) {
    flex: 1 1 15%;
  }
`;

export const StyledTableRow = styled(TableRow)`
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  height: 60px;

  &:hover {
    background-color: ${customPalette.grey[0]};
  }

  &:last-child td {
    border-bottom: none;
  }
`;

export const StyledTableHead = styled(TableHead)`
  display: flex;
  padding-left: 5px;
  font-weight: 600;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  height: 60px;

  &:hover {
    background-color: ${customPalette.grey[0]};
  }
`;

export const StyledHeaderTableCell = styled(StyledTableCell)`
  font-weight: 600;
`;

export const DocumentLink = styled.span`
  cursor: pointer;
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const ViewAllWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
`;

export const StyledDownloadIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
`;

export const FilterButton = styled.button`
  margin-left: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: gray;
`;

export const FilterBox = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  padding: 16px;
  z-index: 100;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const Checkbox = styled.input`
  margin-right: 8px;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
`;

export const SearchInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchInput = styled.input`
  padding: 6px 30px 6px 8px; /* Right padding for icon space */
  border: 1px solid #ccc;
  outline: none;
  width: ${(props) => (props.visible ? '150px' : '0px')}; /* Expanding effect */
  opacity: ${(props) => (props.visible ? '1' : '0')}; /* Fade-in effect */
  transition:
    width 0.3s ease-in-out,
    opacity 0.2s ease-in-out; /* Smooth transition */
  border-radius: 4px;
  overflow: hidden;
  white-space: nowrap;
`;

export const YearSearchInput = styled.input`
  padding: 6px 30px 6px 8px; /* Right padding for icon space */
  border: 1px solid #ccc;
  outline: none;
  width: ${(props) => (props.visible ? '100px' : '0px')}; /* Expanding effect */
  opacity: ${(props) => (props.visible ? '1' : '0')}; /* Fade-in effect */
  transition:
    width 0.3s ease-in-out,
    opacity 0.2s ease-in-out; /* Smooth transition */
  border-radius: 4px;
  overflow: hidden;
  white-space: nowrap;
`;

export const DateSearchInput = styled.input`
  padding: 6px 30px 6px 8px; /* Right padding for icon space */
  border: 1px solid #ccc;
  outline: none;
  width: ${(props) => (props.visible ? '120px' : '0px')}; /* Expanding effect */
  opacity: ${(props) => (props.visible ? '1' : '0')}; /* Fade-in effect */
  transition:
    width 0.3s ease-in-out,
    opacity 0.2s ease-in-out; /* Smooth transition */
  border-radius: 4px;
  overflow: hidden;
  white-space: nowrap;
`;

export const SearchIconComponent = styled(SearchIcon)`
  cursor: pointer;
  color: gray;
`;

export const SearchIconInside = styled(SearchIcon)`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: gray;
  pointer-events: none; /* Avoid interaction */
`;
